import React, { Component } from 'react'
import { Drawer, Form, Button, Col, Row, Input, Select, DatePicker } from 'antd'
import moment from 'moment'
import Map from './CreateEnquiryMap'
import { Client } from 'fulcrum-app'

const client = new Client(process.env.REACT_APP_SECRET_KEY)

const { Option } = Select;
const initialState = {
  lat: -38.2378199,
  lng: 146.3787252,
  date: null,
  name: null,
  email: null,
  phone: null,
  boreType: null,
  licence: null,
  depth: null,
  address: null,
  additionalInformation: null,
  entireQualityPlan: null
}
export const CreateEnquiry = Form.create()(
  class extends Component {
    state = {
      lat: -38.2378199,
      lng: 146.3787252,
      date: null,
      name: null,
      email: null,
      phone: null,
      boreType: null,
      licence: null,
      depth: null,
      address: null,
      additionalInformation: null,
      entireQualityPlan: null
    }
    createButton(onCreate, onUpdate) {
      return (this.props.viewEnquiry) ?
        <Button onClick={() => {onUpdate(this.state.entireQualityPlan); this.setState(initialState)}} ghost type="primary">Update</Button>
        :
        <Button onClick={() => {onCreate(); this.setState(initialState)}} type="primary">Create</Button>
    }
    componentDidUpdate(prevProps, prevState) {
      if (prevProps.viewEnquiry !== this.props.viewEnquiry) {
        this.loadEnquiry(this.props.viewEnquiry)
      }
    }
    loadEnquiry(record) {
      if (record) {
        client.records.find(record.id)
          .then((resp) => {
            this.setState({
              lat: (resp.form_values['c3f2']) ? parseFloat(resp.form_values['c3f2']) : -38.2378199,
              lng: (resp.form_values['6aae']) ? parseFloat(resp.form_values['6aae']) : 146.3787252,
              date: resp.form_values['ce91'],
              name: resp.form_values['6612'],
              email: resp.form_values['b89a'],
              phone: resp.form_values['c0bc'],
              boreType: (resp.form_values['c2eb']) ? resp.form_values['c2eb'].choice_values[0] : null,
              licence: resp.form_values['4aad'],
              depth: resp.form_values['85fa'],
              address: resp.form_values['ba02'],
              additionalInformation: resp.form_values['29fd'],
              entireQualityPlan: resp
            })
          })
          .catch(err => console.log(err))
      }
    }


    render() {
      const { visible, onClose, form, onCreate, onUpdate } = this.props;
      const { getFieldDecorator } = form;
      var marker = [{
        id: 'placed',
        latitude: this.state.lat,
        longitude: this.state.lng
      }]
      return (
        <div>
          <Drawer
            title="Create Client Enquiry"
            className='clientEnquiry'
            width={800}
            placement="right"
            onClose={() => {onClose(); this.setState(initialState)}}
            maskClosable={false}
            visible={visible}
            style={{
              height: 'calc(100% - 55px)',
              overflow: 'auto',
              paddingBottom: 53,
            }}>
            <Form layout="vertical" hideRequiredMark>
              <Row>
                <Form.Item label="Date">
                  {getFieldDecorator('date', {
                    rules: [{ required: true, message: 'Please choose the date' }],
                    initialValue: (this.state.date) ? moment(this.state.date, 'YYYY-MM-DD') : moment()
                  })(
                    <DatePicker
                      style={{ width: '100%' }}
                      getPopupContainer={trigger => trigger.parentNode}
                      format='Do MMMM YYYY'
                    />
                  )}
                </Form.Item>
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item label="Name">
                    {getFieldDecorator('name', {
                      rules: [{ required: true, message: 'Please enter client name' }],
                      initialValue: (this.state.name) ? this.state.name : null
                    })(<Input placeholder="John Smith" />)}
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Email">
                    {getFieldDecorator('email', {
                      rules: [{ required: false, message: 'please enter client email' }],
                      initialValue: (this.state.email) ? this.state.email : null
                    })(<Input placeholder="johnsmith@hotmail.com" />)}
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Phone Number">
                    {getFieldDecorator('phone', {
                      rules: [{ required: false, message: 'please enter client phone number' }],
                      initialValue: (this.state.phone) ? this.state.phone : null
                    })(<Input placeholder="0412 123 123" />)}
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item label="Bore Type">
                    {getFieldDecorator('boreType', {
                      initialValue: (this.state.boreType) ? this.state.boreType : null
                    })(
                      <Select>
                        <Option value="S&D">S&D</Option>
                        <Option value="Irrigation">Irrigation</Option>
                        <Option value="Coring">Coring</Option>
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Bore Construction Licence">
                    {getFieldDecorator('boreLicence', {
                      initialValue: (this.state.licence) ? this.state.licence : null
                    })(
                      <Select>
                        <Option value="yes">Yes</Option>
                        <Option value="no">No</Option>
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Approximate Depth">
                    {getFieldDecorator('depth', {
                      initialValue: (this.state.depth) ? this.state.depth : null
                    })(
                      <Input.TextArea rows={1} />
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Form.Item label="Address">
                  {getFieldDecorator('address', {
                    initialValue: (this.state.address) ? this.state.address : null
                  })(
                    <Input.TextArea rows={1} />
                  )}
                </Form.Item>
              </Row>
              <Row>
                <Map
                  googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyALSdb8pDixxuFtKtAHTfss_cW7bvI6IOY&v=3.exp&libraries=geometry,drawing,places"
                  loadingElement={<div style={{ height: `100%` }} />}
                  containerElement={
                    <div
                      style={{
                        height: `350px`,
                        border: '1px solid #e8e8e8',
                        borderRadius: '4px',
                        marginBottom: '15px'
                      }}
                    />}
                  mapElement={<div style={{ height: `100%` }} />}
                  placedMarker={marker}
                  getLocation={(lat, lng) => {
                    this.setState({
                      lat,
                      lng
                    })
                  }}
                />
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item >
                    {getFieldDecorator('lat',
                      { initialValue: this.state.lat })(
                        <Input disabled size='small' addonBefore="Lat" />
                      )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item >
                    {getFieldDecorator('lng',
                      { initialValue: this.state.lng })(
                        <Input disabled size='small' addonBefore="Lng" />
                      )}
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item label="Additional Information">
                    {getFieldDecorator('information', {
                      initialValue: (this.state.additionalInformation) ? this.state.additionalInformation : null
                    })(
                      <Input.TextArea rows={4} />
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            <div style={{
              position: 'absolute',
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e8e8e8',
              padding: '10px 16px',
              textAlign: 'right',
              left: 0,
              background: '#fff',
              borderRadius: '0 0 4px 4px',
            }}>
              <Button style={{ marginRight: 8 }} onClick={() => {onClose(); this.setState(initialState)}}>
                Cancel
              </Button>
              {this.createButton(onCreate, onUpdate)}
            </div>
          </Drawer>
        </div>
      )
    }
  }
)